import { createPortal } from 'react-dom';

// Every modal's dimmed backdrop (.modal-overlay, styles.css), rendered
// straight onto <body> — not inside #root, whose stacking context (it's
// position:fixed) kept modals below the scene-loading overlay
// (#upload-overlay, also on <body>), so the header stayed undimmed while a
// model loaded. On <body> the backdrop covers the whole screen, header
// included, above the loading overlay, and the card is centred in the
// visible viewport the same way everywhere.
const ModalOverlay = ({ children, ...props }) => createPortal(
  <div className="modal-overlay" {...props}>{children}</div>,
  document.body,
);

export default ModalOverlay;
